export default __webpack_public_path__ + "static/media/7.4bf5055a.jpg";